import { h, createContext, ComponentChildren } from 'preact';
import { useContext, useEffect, useState, useCallback } from 'preact/hooks';
import { fetchBillingMeta, BillingMeta } from '../services/api';

interface BillingContextValue {
  subscription: BillingMeta['subscription'];
  loading: boolean;
  refresh: () => Promise<void>;
}

const BillingContext = createContext<BillingContextValue>({
  subscription: null,
  loading: true,
  refresh: async () => {},
});

export function BillingProvider({ children }: { children: ComponentChildren }) {
  const [subscription, setSubscription] = useState<BillingMeta['subscription']>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { subscription } = await fetchBillingMeta();
      setSubscription(subscription);
    } catch {
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BillingContext.Provider value={{ subscription, loading, refresh }}>
      {children}
    </BillingContext.Provider>
  );
}

export function useBilling(): BillingContextValue {
  return useContext(BillingContext);
}
